import type { LawFirmReceiptPrintRecord } from '~/models'
import { $apiGet } from '~/utils/request'

export const GetByLawFirmReceiptEncryptionId = params => $apiGet<LawFirmReceiptPrintRecord[]>(`/v1/lawFirmReceiptPrintRecord/byLawFirmReceiptEncryptionId`, params)
